// extracted by mini-css-extract-plugin
export default {"tipsSection":"Tips_tipsSection__+yRH6","tipsGrid":"Tips_tipsGrid__21E8N","tipCard":"Tips_tipCard__naKye","icon":"Tips_icon__ErzCv"};